import { FilterInstance, FilterKind } from '../types';

function filterInFrontend<ColKeys extends string, Row extends Record<string, any>>(
  filter: FilterInstance<ColKeys>,
  row: Row
): boolean {
  const colKey = Object.keys(filter)[0] as ColKeys;

  const enumValueArray = filter[colKey].in;

  if (enumValueArray.length === 0) {
    return true;
  }

  // cell is null or undefined and we are looking for something
  if (row[colKey] === null || row[colKey] === undefined) {
    return false;
  }

  if (Array.isArray(row[colKey])) {
    return row[colKey].some((value: any) => enumValueArray.includes(value));
  }

  return enumValueArray.includes(row[colKey]);
}

export const inFilter: FilterKind = {
  filterInFrontend,
};
